import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CountryLocation } from 'config/types/user.type';
import { CountryDisplay, DEFAULT_COUNTRY_DISPLAY, HomeIsland, StoreSettings } from 'store/models/setting.model';

const initialState: StoreSettings = {
  isFetching: false,
  homeIslands: [],
  countryLocations: [],
  countryDisplay: DEFAULT_COUNTRY_DISPLAY,
};

const settingSlice = createSlice({
  name: 'setting',
  initialState,
  reducers: {
    refreshCountryLocations: (state, action: PayloadAction<CountryLocation[]>) => {
      state.countryLocations = action.payload;
      return state;
    },
    fetchingRefresh: (state, action: PayloadAction<boolean>) => {
      state.isFetching = action.payload;
      return state;
    },
    refreshHomeIslands: (state, action: PayloadAction<HomeIsland[]>) => {
      state.homeIslands = action.payload ?? [];
      return state;
    },
    refreshCountryDisplay: (state, action: PayloadAction<CountryDisplay>) => {
      state.countryDisplay = action.payload;
      return state;
    },
    resetSettingStore: () => initialState,
  },
});

export const SettingSlice = settingSlice.actions;
export default settingSlice.reducer;
